import { useEffect, useMemo, useState } from "react";
import {
  countInRevenue,
  getAcquistionsListTable,
  getAcquistionsNewListTable,
  getCallRails,
  getCallRailsCallDetails,
  getCallSummary,
  getCostByChannelAds,
  getCostByChannelByMonthAds,
  getDailyClicks,
  getDashboardData,
  getEmailCampaigns,
  getLeadListTable,
  getReviewGrowth,
  getReviewRatingDashboard,
  getSentiments,
  manualMatchLeads,
  matchCallLeads,
  updateCall,
  updateCallRecord,
} from "../../services/newdashboard";
import { useAppSelector } from "../../store/hook";
import moment from "moment";
import {
  formatCalcNumber,
  formatter,
  numFormatter,
} from "../../helpers/currency";
import { getAdsData } from "../../services/google";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  BarElement,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { useNavigate, useSearchParams } from "react-router-dom";
import _, { divide, uniqBy } from "lodash";
import { DatePicker, Table } from "antd";
import { useDispatch } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import {
  Modal,
  OverlayTrigger,
  Spinner,
  Tooltip as BSTooltip,
} from "react-bootstrap";
import UpdateOnlineLeads from "./updateOnlineLeads";
import UpdateAcquisition from "./updateAcquisition";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import CustomDialog from "./CustomDialog";
import InfoModal from "./InfoModal";
import { getSyncLeadsData } from "../../services/configurations";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  BarElement
);

export const CallsDashboard = () => {
  const { RangePicker } = DatePicker;
  const [searchParams] = useSearchParams();
  const [lastUsedDatePicker, setLastUsedDatePicker] = useState<
    "month" | "range" | null
  >(null);
  const user = useAppSelector((state) => state.user.user);
  const clinics = useAppSelector((state) => state.user.user.clinics);
  const [selectedClinic, setSelectedClinic] = useState(
    searchParams.get("clinic")
      ? searchParams.get("clinic")
      : sessionStorage.getItem("selectedClinic") &&
        sessionStorage.getItem("selectedClinic") !== ""
      ? sessionStorage.getItem("selectedClinic")
      : clinics?.[0]?.uniqueId
  );
  const clinicData = clinics?.find(
    (item: any) => item.uniqueId === selectedClinic
  );
  const month = useMemo(() => {
    let retLabel = 0;
    switch (searchParams.get("filter")) {
      case "thismonths":
        retLabel = 0;
        break;
      case "1months":
        retLabel = 1;
        break;
      case "3months":
        retLabel = 3;
        break;
      case "6months":
        retLabel = 6;
        break;
      case "9months":
        retLabel = 9;
        break;
      case "12months":
        retLabel = 12;
        break;
    }
    return retLabel;
  }, [searchParams]);
  const [dateFilter, setDateFilter] = useState({
    startDate: month
      ? moment().subtract(month, "months").startOf("month").format("YYYY-MM-DD")
      : moment().startOf("month").format("YYYY-MM-DD"),
    endDate: month
      ? moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD"),
  });
  const [selectedQuater, setSelectedQuater] = useState(
    searchParams.get("filter")
      ? searchParams.get("filter") ?? "thismonths"
      : "thismonths"
  );
  const [leadListTable, setLeadListTable] = useState([]);
  const [acquisitionsListTable, setAcquisitionsListTable] = useState([]);
  const [callRailCallDetailsTable, setCallRailCallDetailsTable] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [transcript, setTranscript] = useState([]);
  const [tags, setTags] = useState([]);
  const [summary, setSummary] = useState([]);
  const [callRailCallDetailsTablePL, setCallRailCallDetailsTablePL] = useState(
    []
  );
  const [callRailCallDetailsOLTable, setCallRailCallDetailsOLTable] = useState(
    []
  );
  const [callRailCallDetailsOLTablePL, setCallRailCallDetailsOLTablePL] =
    useState([]);
  const [callSummaryData, setCallSummaryData] = useState({} as any);
  const [callSummaryChart, setCallSummaryChart] = useState<any>({
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
        },
        title: {
          display: false,
        },
      },
      scales: {
        x: {
          stacked: true,
          // to remove the x-axis grid
          grid: {
            drawBorder: false,
            display: false,
          },
        },
        y: {
          stacked: true,
          // to remove the y-axis grid
          grid: {
            drawBorder: false,
            display: false,
          },
        },
      },
    },
    data: {} as any,
  });
  const [year, setYear] = useState(moment().toDate());
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [infoRowData, setInfoRowData] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenAcquisition, setIsModalOpenAcquisition] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [newAcquisitions, setNewAcquisitions] = useState([]);
  const [leftSide, setLeftSide] = useState<any[]>([]);
  const [rightSide, setRigtSide] = useState<any[]>([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  if (!selectedClinic && clinics?.[0]?.uniqueId) {
    setSelectedClinic(clinics?.[0]?.uniqueId);
  }
  useEffect(() => {
    if (selectedClinic !== undefined) {
      getData();
      getSuncLeadsData();
    }
  }, [selectedClinic, dateFilter, clinicData]);

  const getData = () => {
    getLeadListTable(
      selectedClinic,
      `?startDate=${dateFilter?.startDate}&endDate=${dateFilter?.endDate}`
    )
      .then((success) => {
        setLeadListTable(success?.list);
      })
      .catch((error) => {
        console.log(error);
      });

    getAcquistionsListTable(
      selectedClinic,
      `?startDate=${dateFilter?.startDate}&endDate=${dateFilter?.endDate}`
    )
      .then((success) => {
        setAcquisitionsListTable(success?.list);
      })
      .catch((error) => {
        console.log(error);
      });

    getCallRailsCallDetails(
      selectedClinic,
      `?startDate=${dateFilter?.startDate}&endDate=${dateFilter?.endDate}&status=none`
    )
      .then((success) => {
        setCallRailCallDetailsTable(success.data);
        setCallRailCallDetailsTablePL(success.patientList);
      })
      .catch((error) => {});

    getCallRailsCallDetails(
      selectedClinic,
      `?startDate=${dateFilter?.startDate}&endDate=${dateFilter?.endDate}&status=Opportunity Lost`
    ).then((success) => {
      setCallRailCallDetailsOLTable(success.data);
      setCallRailCallDetailsOLTablePL(success.patientList);
    });

    getCallSummary(
      selectedClinic,
      `?startDate=${dateFilter?.startDate}&endDate=${dateFilter?.endDate}`
    )
      .then((success) => {
        setCallSummaryData(success.data);
        const totalCalls: any[] = [];
        const missedCalls: any[] = [];
        const answeredCalls: any[] = [];
        const firstTimeCallers: any[] = [];
        const averageDuration: any = [];
        const formattedAverageDuration: any = [];
        const leads: any = [];
        success?.data?.data?.forEach((item: any) => {
          totalCalls.push(item.total_calls);
          missedCalls.push(item.missed_calls);
          answeredCalls.push(item.answered_calls);
          firstTimeCallers.push(item.first_time_callers);
          averageDuration.push(item.average_duration);
          formattedAverageDuration.push(item.formatted_average_duration);
          leads.push(item.leads);
        });
        setCallSummaryChart({
          ...callSummaryChart,
          data: {
            labels: success?.data?.data?.map((item: any) => item.date),
            datasets: [
              {
                label: "Total calls",
                data: totalCalls,
                backgroundColor: "#8dc44f",
              },
              {
                label: "Missed calls",
                data: missedCalls,
                backgroundColor: "#1ca45c",
              },
              {
                label: "Answered calls",
                data: answeredCalls,
                backgroundColor: "#ffc718",
              },
              {
                label: "First time callers",
                data: firstTimeCallers,
                backgroundColor: "#ff9e0f",
              },
              /* {
                        label: 'Average duration',
                        data: averageDuration,
                        backgroundColor: "#da483b",
                      }, */
              {
                label: "Average duration",
                data: formattedAverageDuration,
                backgroundColor: "#4486f4",
              },
              {
                label: "Leads",
                data: leads,
                backgroundColor: "#4956f4",
              },
            ],
          },
        });
      })
      .catch((error) => {});

    getAcquistionsNewListTable(
      selectedClinic,
      `?startDate=${dateFilter?.startDate}&endDate=${dateFilter?.endDate}`
    )
      .then((success) => {
        setNewAcquisitions(success?.list);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getSuncLeadsData = () => {
    getSyncLeadsData(selectedClinic, {
      year: new Date(dateFilter?.startDate).getFullYear(),
      month: moment(month).format("MM"),
    })
      .then((success: any) => {
        if (success.status?.error === false) {
          setLeftSide([
            ...success.xcareList,
            ...success.guestList?.map((item: any) => ({
              id: item.leftId,
              ...item,
            })),
          ]);
          setRigtSide(success.pmsList);
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const getMappedSource = (item: any) => {
    if (item.source === "onlinescheduling") {
      return "Xcare";
    } else if (
      item.source !== "seo" &&
      item.source !== "gmb" &&
      item.source !== "instagram" &&
      item.source !== "meta-ads" &&
      item.source !== "google-ads" &&
      item.source !== "offer-mail" &&
      item.source !== "google-mail" &&
      item.source !== "google" &&
      item.source !== "facebook" &&
      !item.source.includes("email")
    ) {
      return "Xcare";
    } else {
      return item.source;
    }
  };
  let leadListTableMapped = leadListTable?.map((item: any) => {
    return {
      ...item,
      source: getMappedSource(item),
      name: item.fname + " " + item.lname,
      nextAppt: item?.nextAppointment?.date,
    };
  });
  const sourceFilters = uniqBy(
    uniqBy(
      leadListTable?.map((item: any) => ({
        text: item.source,
        value: item.source,
      })),
      "value"
    )?.map((item) => {
      if (item.value === "onlinescheduling") {
        return { text: "Xcare", value: "Xcare" };
      } else if (
        item.value !== "seo" &&
        item.value !== "gmb" &&
        item.value !== "instagram" &&
        item.value !== "meta-ads" &&
        item.value !== "google-ads" &&
        item.value !== "offer-mail" &&
        item.value !== "google-mail" &&
        item.value !== "google" &&
        item.value !== "facebook" &&
        !item.value.includes("email")
      ) {
        return { text: "Xcare", value: "Xcare" };
      } else {
        return item;
      }
    }),
    "value"
  );
  const nameFilters = uniqBy(
    leadListTable?.map((item: any) => ({
      text: item.fname + " " + item.lname,
      value: item.fname + " " + item.lname,
    })),
    "value"
  );
  const emailFilters = uniqBy(
    leadListTable?.map((item: any) => ({
      text: item.email,
      value: item.email,
    })),
    "value"
  );
  const phoneFilters = uniqBy(
    leadListTable?.map((item: any) => ({
      text: item.phone,
      value: item.phone,
    })),
    "value"
  );
  const statusFilters = uniqBy(
    leadListTable?.map((item: any) => ({
      text: item.status,
      value: item.status,
    })),
    "value"
  );
  const typeFilters = uniqBy(
    leadListTable?.map((item: any) => ({ text: item.type, value: item.type })),
    "value"
  );

  type Message = {
    speaker: "Agent" | "Caller";
    text: string;
  };

  const columns: any = [
    {
      title: "Source",
      dataIndex: "source",
      filters: sourceFilters,
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      onFilter: (value: string, record: any) =>
        record.source.indexOf(value) === 0,
      sorter: (a: any, b: any) => a.source.length - b.source.length,
      // sortDirections: ['descend'],
      render: (text: any) => {
        if (text === "onlinescheduling") {
          return (
            <img
              src={require("../../assets/images/xcare-api-icon.png")}
              width={14}
              height={14}
            ></img>
          );
        } else if (text === "google-mail") {
          return <i className="bi bi-envelope"></i>;
        } else if (text === "facebook") {
          return <i className="bi bi-facebook"></i>;
        } else if (text === "offer-mail") {
          return <i className="bi bi-coin"></i>;
        } else if (text === "google") {
          return <i className="bi bi-google"></i>;
        } else if (text === "instagram") {
          return <i className="bi bi-instagram"></i>;
        } else if (text?.includes("email")) {
          return <i className="bi bi-envelope"></i>;
        } else if (text === "google-ads") {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="12"
              height="12"
              viewBox="0 -13 256 256"
              version="1.1"
            >
              <g>
                <path
                  d="M5.888,166.405103 L90.88,20.9 C101.676138,27.2558621 156.115862,57.3844138 164.908138,63.1135172 L79.9161379,208.627448 C70.6206897,220.906621 -5.888,185.040138 5.888,166.396276 L5.888,166.405103 Z"
                  fill="#FBBC04"
                ></path>
                <path
                  d="M250.084224,166.401789 L165.092224,20.9055131 C153.210293,1.13172 127.619121,-6.05393517 106.600638,5.62496138 C85.582155,17.3038579 79.182155,42.4624786 91.0640861,63.1190303 L176.056086,208.632961 C187.938017,228.397927 213.52919,235.583582 234.547672,223.904686 C254.648086,212.225789 261.966155,186.175582 250.084224,166.419444 L250.084224,166.401789 Z"
                  fill="#4285F4"
                ></path>
                <ellipse
                  fill="#34A853"
                  cx="42.6637241"
                  cy="187.924414"
                  rx="42.6637241"
                  ry="41.6044138"
                ></ellipse>
              </g>
            </svg>
          );
        } else if (text === "gmb") {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="12"
              width="12"
              viewBox="0 0.43 1064 928.69"
            >
              <linearGradient
                id="a"
                x1="0%"
                x2="99.999%"
                y1="49.999%"
                y2="49.999%"
              >
                <stop offset=".03" stop-color="#4079d8" />
                <stop offset="1" stop-color="#4989f5" />
              </linearGradient>
              <g fill="none" fill-rule="evenodd">
                <g fill-rule="nonzero">
                  <rect
                    fill="#4989f5"
                    height="696.14"
                    rx="36.88"
                    width="931"
                    x="53.45"
                    y="232.98"
                  />
                  <path
                    d="M936.81 227.75H100.06c-25.92 0-46.09 200.6-46.09 226.52L512.2 929.12h424.61c26-.071 47.059-21.13 47.13-47.13V274.87c-.077-25.996-21.134-47.049-47.13-47.12z"
                    fill="url(#a)"
                  />
                  <path d="M266.03 349.56h266V.44H305.86z" fill="#3c4ba6" />
                  <path
                    d="M798.03 349.56h-266V.44H758.2zM984.45 66.62l.33 1.19c-.08-.42-.24-.81-.33-1.19z"
                    fill="#7babf7"
                  />
                  <path
                    d="M984.78 67.8l-.33-1.19C976.017 27.993 941.837.455 902.31.43H758.2L798 349.56h266z"
                    fill="#3f51b5"
                  />
                  <path
                    d="M79.61 66.62l-.33 1.19c.08-.42.24-.81.33-1.19z"
                    fill="#7babf7"
                  />
                  <path
                    d="M79.27 67.8l.33-1.19C88.033 27.993 122.213.455 161.74.43h144.12L266 349.56H0z"
                    fill="#7babf7"
                  />
                </g>
                <path
                  d="M266.48 349.47c0 73.412-59.513 132.925-132.925 132.925S.63 422.882.63 349.47z"
                  fill="#709be0"
                />
                <path
                  d="M532.33 349.47c0 73.412-59.513 132.925-132.925 132.925S266.48 422.882 266.48 349.47z"
                  fill="#3c4ba6"
                />
                <path
                  d="M798.18 349.47c0 73.412-59.513 132.925-132.925 132.925S532.33 422.882 532.33 349.47z"
                  fill="#709be0"
                />
                <path
                  d="M1064 349.47c0 73.412-59.513 132.925-132.925 132.925S798.15 422.882 798.15 349.47z"
                  fill="#3c4ba6"
                />
                <path
                  d="M931.08 709.6c-.47-6.33-1.25-12.11-2.36-19.49h-145c0 20.28 0 42.41-.08 62.7h84a73.05 73.05 0 0 1-30.75 46.89s0-.35-.06-.36a88 88 0 0 1-34 13.27 99.85 99.85 0 0 1-36.79-.16 91.9 91.9 0 0 1-34.31-14.87 95.72 95.72 0 0 1-33.73-43.1c-.52-1.35-1-2.71-1.49-4.09v-.15l.13-.1a93 93 0 0 1-.05-59.84A96.27 96.27 0 0 1 718.9 654c23.587-24.399 58.829-33.576 91.32-23.78a83 83 0 0 1 33.23 19.56l28.34-28.34c5-5.05 10.19-9.94 15-15.16a149.78 149.78 0 0 0-49.64-30.74 156.08 156.08 0 0 0-103.83-.91c-1.173.4-2.34.817-3.5 1.25A155.18 155.18 0 0 0 646 651a152.61 152.61 0 0 0-13.42 38.78c-16.052 79.772 32.623 158.294 111.21 179.4 25.69 6.88 53 6.71 78.89.83a139.88 139.88 0 0 0 63.14-32.81c18.64-17.15 32-40 39-64.27a179 179 0 0 0 6.26-63.33z"
                  fill="#fff"
                  fill-rule="nonzero"
                />
              </g>
            </svg>
          );
        } else if (text === "seo") {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              fill="#000000"
              height="14"
              width="14"
              version="1.1"
              id="Layer_1"
              viewBox="0 0 512 512"
              xmlSpace="preserve"
            >
              <g>
                <g>
                  <g>
                    <path d="M497.453,241.022l-43.995-114.147l43.984-113.132c1.207-3.104,0.805-6.603-1.077-9.352C494.485,1.644,491.37,0,488.039,0     H23.961c-5.571,0-10.089,4.517-10.089,10.089v491.823c0,5.571,4.517,10.089,10.089,10.089h50.443     c5.571,0,10.089-4.517,10.089-10.089V254.739h403.547c3.325,0,6.437-1.638,8.318-4.381     C498.239,247.618,498.649,244.124,497.453,241.022z M64.315,491.823H34.049V20.177h30.266V491.823z M84.493,234.562V20.177     h388.801l-40.056,103.025c-0.912,2.342-0.916,4.94-0.011,7.284l40.113,104.075H84.493z" />
                    <path d="M135.566,66.837h47.291c5.571,0,10.089-4.517,10.089-10.089s-4.517-10.089-10.089-10.089h-47.291     c-18.427,0-33.419,14.992-33.419,33.419v23.961c0,18.427,14.992,33.419,33.419,33.419c0.537,0,1.062-0.054,1.576-0.135     c0.514,0.081,1.039,0.135,1.576,0.135h20.808c7.302,0,13.241,5.94,13.241,13.241v23.961c0,7.302-5.94,13.241-13.241,13.241     h-47.291c-5.571,0-10.089,4.517-10.089,10.089c0,5.571,4.517,10.089,10.089,10.089h47.291c18.427,0,33.419-14.992,33.419-33.419     V150.7c0-18.427-14.992-33.419-33.419-33.419h-20.808c-0.537,0-1.062,0.054-1.576,0.135c-0.515-0.081-1.039-0.135-1.576-0.135     c-7.302,0-13.241-5.94-13.241-13.241V80.079C122.325,72.777,128.265,66.837,135.566,66.837z" />
                    <path d="M246.542,66.837h47.291c5.571,0,10.089-4.517,10.089-10.089s-4.517-10.089-10.089-10.089h-47.291     c-18.427,0-33.419,14.992-33.419,33.419v47.291v47.291c0,18.427,14.992,33.419,33.419,33.419h47.291     c5.571,0,10.089-4.517,10.089-10.089c0-5.571-4.517-10.089-10.089-10.089h-47.291c-7.302,0-13.241-5.94-13.241-13.241v-37.202     h60.532c5.571,0,10.089-4.517,10.089-10.089s-4.517-10.089-10.089-10.089H233.3V80.079     C233.3,72.777,239.24,66.837,246.542,66.837z" />
                    <path d="M381.478,46.66h-23.961c-18.427,0-33.419,14.992-33.419,33.419v94.581c0,18.427,14.992,33.419,33.419,33.419h23.961     c18.427,0,33.419-14.992,33.419-33.419V80.079C414.896,61.652,399.905,46.66,381.478,46.66z M394.719,174.66     c0,7.302-5.94,13.241-13.241,13.241h-23.961c-7.302,0-13.241-5.94-13.241-13.241V80.079c0-7.302,5.94-13.241,13.241-13.241     h23.961c7.302,0,13.241,5.94,13.241,13.241V174.66z" />
                    <path d="M316.532,293.833c0-5.571-4.517-10.089-10.089-10.089h-186.64c-5.571,0-10.089,4.517-10.089,10.089     s4.517,10.089,10.089,10.089h186.64C312.015,303.921,316.532,299.404,316.532,293.833z" />
                    <path d="M479.212,324.099H296.355c-5.571,0-10.089,4.517-10.089,10.089s4.517,10.089,10.089,10.089h182.857     c5.571,0,10.089-4.517,10.089-10.089S484.783,324.099,479.212,324.099z" />
                  </g>
                </g>
              </g>
            </svg>
          );
        } else if (text === "meta-ads") {
          return <i className="bi bi-meta"></i>;
        }
        return (
          <img
            src={require("../../assets/images/xcare-api-icon.png")}
            width={14}
            height={14}
          ></img>
        );
      },
    },
    {
      title: "Appt. Date",
      dataIndex: "date",
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      onFilter: (value: string, record: any) =>
        record.source.indexOf(value) === 0,
      sorter: (a: any, b: any) =>
        moment(a.date + " " + a.time).unix() -
        moment(b.date + " " + b.time).unix(),
      // sortDirections: ['descend'],
      render: (text: any, row: any) => (
        <>
          <p className="mb-0">{text}</p>
          <p className="mb-0">{row.time}</p>
        </>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      filters: nameFilters,
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      onFilter: (value: string, record: any) =>
        record.name.indexOf(value) === 0,
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
      // sortDirections: ['descend'],
      render: (text: any) => <p>{text}</p>,
    },

    {
      title: "Email",
      dataIndex: "email",
      filters: emailFilters,
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      onFilter: (value: string, record: any) =>
        record.email.indexOf(value) === 0,
      sorter: (a: any, b: any) => a.email.length - b.email.length,
      // sortDirections: ['descend'],
      render: (text: any) => <p>{text}</p>,
    },

    {
      title: "Phone#",
      dataIndex: "phone",
      filters: phoneFilters,
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      onFilter: (value: string, record: any) =>
        record?.phone?.indexOf(value) === 0,
      sorter: (a: any, b: any) => a?.phone?.length - b?.phone?.length,
      // sortDirections: ['descend'],
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "Appt. created date",
      dataIndex: "createdAt",
    },
    {
      title: "Status",
      dataIndex: "status",
      filters: statusFilters,
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      onFilter: (value: string, record: any) =>
        record.status.indexOf(value) === 0,
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
      // sortDirections: ['descend'],
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "Revenue",
      dataIndex: "revenue",
      sorter: (a: any, b: any) => a?.revenue - b?.revenue,
      // sortDirections: ['descend'],
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "Type",
      dataIndex: "type",
      filters: typeFilters,
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      onFilter: (value: string, record: any) =>
        record.type.indexOf(value) === 0,
      sorter: (a: any, b: any) => a.type.length - b.type.length,
      // sortDirections: ['descend'],
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "Count in revenue",
      dataIndex: "action",
      render: (text: any, row: any) => (
        <CountInRevenue row={row} handleCountInRevenue={handleCountInRevenue} />
      ),
    },
  ];

  /* Acquisitions */
  let acquisitionsListTableMapped = acquisitionsListTable?.map((item: any) => {
    return {
      ...item,
      source: getMappedSource(item),
      name: item.fname + " " + item.lname,
      nextAppt: item?.date,
    };
  });
  const acquisitionssourceFilters = uniqBy(
    uniqBy(
      acquisitionsListTable?.map((item: any) => ({
        text: item.source,
        value: item.source,
      })),
      "value"
    ).map((item) => {
      if (item.value === "onlinescheduling") {
        return { text: "Xcare", value: "Xcare" };
      } else if (
        item.value !== "seo" &&
        item.value !== "gmb" &&
        item.value !== "instagram" &&
        item.value !== "meta-ads" &&
        item.value !== "google-ads" &&
        item.value !== "offer-mail" &&
        item.value !== "google-mail" &&
        item.value !== "google" &&
        item.value !== "facebook" &&
        !item.value.includes("email")
      ) {
        return { text: "Xcare", value: "Xcare" };
      } else {
        return item;
      }
    }),
    "value"
  );
  const acquisitionsnameFilters = uniqBy(
    acquisitionsListTable?.map((item: any) => ({
      text: item.fname + " " + item.lname,
      value: item.fname + " " + item.lname,
    })),
    "value"
  );
  const acquisitionsemailFilters = uniqBy(
    acquisitionsListTable?.map((item: any) => ({
      text: item.email,
      value: item.email,
    })),
    "value"
  );
  const acquisitionsphoneFilters = uniqBy(
    acquisitionsListTable?.map((item: any) => ({
      text: item.phone,
      value: item.phone,
    })),
    "value"
  );
  const acquisitionsstatusFilters = uniqBy(
    acquisitionsListTable?.map((item: any) => ({
      text: item.status,
      value: item.status,
    })),
    "value"
  );

  const acquisitionscolumns: any = [
    {
      title: "Source",
      dataIndex: "source",
      filters: acquisitionssourceFilters,
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      onFilter: (value: string, record: any) =>
        record.source.indexOf(value) === 0,
      sorter: (a: any, b: any) => a.source.length - b.source.length,
      // sortDirections: ['descend'],
      render: (text: any) => {
        if (text === "onlinescheduling") {
          return (
            <img
              src={require("../../assets/images/xcare-api-icon.png")}
              width={14}
              height={14}
            ></img>
          );
        } else if (text === "google-mail") {
          return <i className="bi bi-envelope"></i>;
        } else if (text === "facebook") {
          return <i className="bi bi-facebook"></i>;
        } else if (text === "offer-mail") {
          return <i className="bi bi-coin"></i>;
        } else if (text === "google") {
          return <i className="bi bi-google"></i>;
        } else if (text === "instagram") {
          return <i className="bi bi-instagram"></i>;
        } else if (text?.includes("email")) {
          return <i className="bi bi-envelope"></i>;
        } else if (text === "google-ads") {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="12"
              height="12"
              viewBox="0 -13 256 256"
              version="1.1"
            >
              <g>
                <path
                  d="M5.888,166.405103 L90.88,20.9 C101.676138,27.2558621 156.115862,57.3844138 164.908138,63.1135172 L79.9161379,208.627448 C70.6206897,220.906621 -5.888,185.040138 5.888,166.396276 L5.888,166.405103 Z"
                  fill="#FBBC04"
                ></path>
                <path
                  d="M250.084224,166.401789 L165.092224,20.9055131 C153.210293,1.13172 127.619121,-6.05393517 106.600638,5.62496138 C85.582155,17.3038579 79.182155,42.4624786 91.0640861,63.1190303 L176.056086,208.632961 C187.938017,228.397927 213.52919,235.583582 234.547672,223.904686 C254.648086,212.225789 261.966155,186.175582 250.084224,166.419444 L250.084224,166.401789 Z"
                  fill="#4285F4"
                ></path>
                <ellipse
                  fill="#34A853"
                  cx="42.6637241"
                  cy="187.924414"
                  rx="42.6637241"
                  ry="41.6044138"
                ></ellipse>
              </g>
            </svg>
          );
        } else if (text === "gmb") {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="12"
              width="12"
              viewBox="0 0.43 1064 928.69"
            >
              <linearGradient
                id="a"
                x1="0%"
                x2="99.999%"
                y1="49.999%"
                y2="49.999%"
              >
                <stop offset=".03" stop-color="#4079d8" />
                <stop offset="1" stop-color="#4989f5" />
              </linearGradient>
              <g fill="none" fill-rule="evenodd">
                <g fill-rule="nonzero">
                  <rect
                    fill="#4989f5"
                    height="696.14"
                    rx="36.88"
                    width="931"
                    x="53.45"
                    y="232.98"
                  />
                  <path
                    d="M936.81 227.75H100.06c-25.92 0-46.09 200.6-46.09 226.52L512.2 929.12h424.61c26-.071 47.059-21.13 47.13-47.13V274.87c-.077-25.996-21.134-47.049-47.13-47.12z"
                    fill="url(#a)"
                  />
                  <path d="M266.03 349.56h266V.44H305.86z" fill="#3c4ba6" />
                  <path
                    d="M798.03 349.56h-266V.44H758.2zM984.45 66.62l.33 1.19c-.08-.42-.24-.81-.33-1.19z"
                    fill="#7babf7"
                  />
                  <path
                    d="M984.78 67.8l-.33-1.19C976.017 27.993 941.837.455 902.31.43H758.2L798 349.56h266z"
                    fill="#3f51b5"
                  />
                  <path
                    d="M79.61 66.62l-.33 1.19c.08-.42.24-.81.33-1.19z"
                    fill="#7babf7"
                  />
                  <path
                    d="M79.27 67.8l.33-1.19C88.033 27.993 122.213.455 161.74.43h144.12L266 349.56H0z"
                    fill="#7babf7"
                  />
                </g>
                <path
                  d="M266.48 349.47c0 73.412-59.513 132.925-132.925 132.925S.63 422.882.63 349.47z"
                  fill="#709be0"
                />
                <path
                  d="M532.33 349.47c0 73.412-59.513 132.925-132.925 132.925S266.48 422.882 266.48 349.47z"
                  fill="#3c4ba6"
                />
                <path
                  d="M798.18 349.47c0 73.412-59.513 132.925-132.925 132.925S532.33 422.882 532.33 349.47z"
                  fill="#709be0"
                />
                <path
                  d="M1064 349.47c0 73.412-59.513 132.925-132.925 132.925S798.15 422.882 798.15 349.47z"
                  fill="#3c4ba6"
                />
                <path
                  d="M931.08 709.6c-.47-6.33-1.25-12.11-2.36-19.49h-145c0 20.28 0 42.41-.08 62.7h84a73.05 73.05 0 0 1-30.75 46.89s0-.35-.06-.36a88 88 0 0 1-34 13.27 99.85 99.85 0 0 1-36.79-.16 91.9 91.9 0 0 1-34.31-14.87 95.72 95.72 0 0 1-33.73-43.1c-.52-1.35-1-2.71-1.49-4.09v-.15l.13-.1a93 93 0 0 1-.05-59.84A96.27 96.27 0 0 1 718.9 654c23.587-24.399 58.829-33.576 91.32-23.78a83 83 0 0 1 33.23 19.56l28.34-28.34c5-5.05 10.19-9.94 15-15.16a149.78 149.78 0 0 0-49.64-30.74 156.08 156.08 0 0 0-103.83-.91c-1.173.4-2.34.817-3.5 1.25A155.18 155.18 0 0 0 646 651a152.61 152.61 0 0 0-13.42 38.78c-16.052 79.772 32.623 158.294 111.21 179.4 25.69 6.88 53 6.71 78.89.83a139.88 139.88 0 0 0 63.14-32.81c18.64-17.15 32-40 39-64.27a179 179 0 0 0 6.26-63.33z"
                  fill="#fff"
                  fill-rule="nonzero"
                />
              </g>
            </svg>
          );
        } else if (text === "seo") {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              fill="#000000"
              height="14"
              width="14"
              version="1.1"
              id="Layer_1"
              viewBox="0 0 512 512"
              xmlSpace="preserve"
            >
              <g>
                <g>
                  <g>
                    <path d="M497.453,241.022l-43.995-114.147l43.984-113.132c1.207-3.104,0.805-6.603-1.077-9.352C494.485,1.644,491.37,0,488.039,0     H23.961c-5.571,0-10.089,4.517-10.089,10.089v491.823c0,5.571,4.517,10.089,10.089,10.089h50.443     c5.571,0,10.089-4.517,10.089-10.089V254.739h403.547c3.325,0,6.437-1.638,8.318-4.381     C498.239,247.618,498.649,244.124,497.453,241.022z M64.315,491.823H34.049V20.177h30.266V491.823z M84.493,234.562V20.177     h388.801l-40.056,103.025c-0.912,2.342-0.916,4.94-0.011,7.284l40.113,104.075H84.493z" />
                    <path d="M135.566,66.837h47.291c5.571,0,10.089-4.517,10.089-10.089s-4.517-10.089-10.089-10.089h-47.291     c-18.427,0-33.419,14.992-33.419,33.419v23.961c0,18.427,14.992,33.419,33.419,33.419c0.537,0,1.062-0.054,1.576-0.135     c0.514,0.081,1.039,0.135,1.576,0.135h20.808c7.302,0,13.241,5.94,13.241,13.241v23.961c0,7.302-5.94,13.241-13.241,13.241     h-47.291c-5.571,0-10.089,4.517-10.089,10.089c0,5.571,4.517,10.089,10.089,10.089h47.291c18.427,0,33.419-14.992,33.419-33.419     V150.7c0-18.427-14.992-33.419-33.419-33.419h-20.808c-0.537,0-1.062,0.054-1.576,0.135c-0.515-0.081-1.039-0.135-1.576-0.135     c-7.302,0-13.241-5.94-13.241-13.241V80.079C122.325,72.777,128.265,66.837,135.566,66.837z" />
                    <path d="M246.542,66.837h47.291c5.571,0,10.089-4.517,10.089-10.089s-4.517-10.089-10.089-10.089h-47.291     c-18.427,0-33.419,14.992-33.419,33.419v47.291v47.291c0,18.427,14.992,33.419,33.419,33.419h47.291     c5.571,0,10.089-4.517,10.089-10.089c0-5.571-4.517-10.089-10.089-10.089h-47.291c-7.302,0-13.241-5.94-13.241-13.241v-37.202     h60.532c5.571,0,10.089-4.517,10.089-10.089s-4.517-10.089-10.089-10.089H233.3V80.079     C233.3,72.777,239.24,66.837,246.542,66.837z" />
                    <path d="M381.478,46.66h-23.961c-18.427,0-33.419,14.992-33.419,33.419v94.581c0,18.427,14.992,33.419,33.419,33.419h23.961     c18.427,0,33.419-14.992,33.419-33.419V80.079C414.896,61.652,399.905,46.66,381.478,46.66z M394.719,174.66     c0,7.302-5.94,13.241-13.241,13.241h-23.961c-7.302,0-13.241-5.94-13.241-13.241V80.079c0-7.302,5.94-13.241,13.241-13.241     h23.961c7.302,0,13.241,5.94,13.241,13.241V174.66z" />
                    <path d="M316.532,293.833c0-5.571-4.517-10.089-10.089-10.089h-186.64c-5.571,0-10.089,4.517-10.089,10.089     s4.517,10.089,10.089,10.089h186.64C312.015,303.921,316.532,299.404,316.532,293.833z" />
                    <path d="M479.212,324.099H296.355c-5.571,0-10.089,4.517-10.089,10.089s4.517,10.089,10.089,10.089h182.857     c5.571,0,10.089-4.517,10.089-10.089S484.783,324.099,479.212,324.099z" />
                  </g>
                </g>
              </g>
            </svg>
          );
        } else if (text === "meta-ads") {
          return <i className="bi bi-meta"></i>;
        }
        return (
          <img
            src={require("../../assets/images/xcare-api-icon.png")}
            width={14}
            height={14}
          ></img>
        );
      },
    },
    {
      title: "Appt. Date",
      dataIndex: "date",
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      onFilter: (value: string, record: any) =>
        record.source.indexOf(value) === 0,
      sorter: (a: any, b: any) =>
        moment(a.date + " " + a.time).unix() -
        moment(b.date + " " + b.time).unix(),
      // sortDirections: ['descend'],
      render: (text: any, row: any) => (
        <>
          <p className="mb-0">{text}</p>
          <p className="mb-0">{row.time}</p>
        </>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      filters: acquisitionsnameFilters,
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      onFilter: (value: string, record: any) =>
        record.name.indexOf(value) === 0,
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
      // sortDirections: ['descend'],
      render: (text: any) => <p>{text}</p>,
    },

    {
      title: "Email",
      dataIndex: "email",
      filters: acquisitionsemailFilters,
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      onFilter: (value: string, record: any) =>
        record.email.indexOf(value) === 0,
      sorter: (a: any, b: any) => a.email.length - b.email.length,
      // sortDirections: ['descend'],
      render: (text: any) => <p>{text}</p>,
    },

    {
      title: "Phone#",
      dataIndex: "phone",
      filters: acquisitionsphoneFilters,
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      onFilter: (value: string, record: any) =>
        record.phone.indexOf(value) === 0,
      sorter: (a: any, b: any) => a.phone.length - b.phone.length,
      // sortDirections: ['descend'],
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "Appt. created date",
      dataIndex: "createdAt",
    },
    {
      title: "Status",
      dataIndex: "status",
      filters: acquisitionsstatusFilters,
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      onFilter: (value: string, record: any) =>
        record.status.indexOf(value) === 0,
      sorter: (a: any, b: any) => a?.status?.localeCompare(b?.status),
      // sortDirections: ['descend'],
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "New Status",
      dataIndex: "newStatus",
      filters: acquisitionsstatusFilters,
      // specify the condition of filtering result
      // here is that finding the name started with `value`
      onFilter: (value: string, record: any) =>
        record.status.indexOf(value) === 0,
      sorter: (a: any, b: any) => a?.status?.localeCompare(b?.status),
      // sortDirections: ['descend'],
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text: any, row: any) => {
        console.log(row, "MJHGFDSA");
        return (
          <div className="flex justify-center gap-2">
            <SyncForOnlineLead
              item={row}
              selectedClinic={selectedClinic}
              refetch={() => {
                // refetch();
              }}
              patientList={rightSide}
            ></SyncForOnlineLead>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setSelectedRow(row);
                setIsModalOpen(true);
              }}
              className="btn btn-sm btn-secondary"
              style={{
                padding: "2px 8px",
                marginTop: "10px",
                backgroundColor: "#4CC9C0",
                border: "none",
              }}
            >
              ✏️
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                console.log(row?.matchedPatient, "row?.matchedPatient");
                setIsInfoModalOpen(true);
                setInfoRowData({ ...row?.matchedPatient, type: row?.type });
              }}
              className="btn btn-sm btn-light"
              style={{
                padding: "2px 8px",
                marginTop: "10px",
                backgroundColor: "#E0E0E0",
                border: "none",
              }}
            >
              <i className="bi bi-info-circle"></i>
            </button>
          </div>
        );
      },
    },
  ];

  const acquisitionsColumns: any = [
    {
      title: "First Name",
      dataIndex: "fname",
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "Last Name",
      dataIndex: "lname",
      sorter: (a: any, b: any) => moment(a.date).unix() - moment(b.date).unix(),
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "Contact",
      sorter: (a: any, b: any) => a.phone.localeCompare(b.phone),
      dataIndex: "phone",
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "Email",
      sorter: (a: any, b: any) => a.email.localeCompare(b.email),
      dataIndex: "email",
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "Created at",
      sorter: (a: any, b: any) => a.source.localeCompare(b.source),
      dataIndex: "createdAt",
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "Source",
      sorter: (a: any, b: any) => a.source.localeCompare(b.source),
      dataIndex: "source",
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "Origin",
      sorter: (a: any, b: any) => a.origin.localeCompare(b.origin),
      dataIndex: "origin",
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "Status",
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
      dataIndex: "status",
      render: (text: any) => <p>{text}</p>,
    },

    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text: any, row: any) => {
        // Parse callData (because it's a JSON string in your API response)
        // let callDataObj: any = null;
        // try {
        //   if (row?.callDetails?.callData) {
        //     callDataObj = JSON.parse(row.callDetails?.callData);
        //   }
        // } catch (error) {
        //   console.error("Invalid callData JSON:", error);
        // }

        return (
          <div className="flex justify-center items-center gap-3">
            {/* Play Icon */}

            <i
              className={`bi bi-play-fill text-xl 
    ${
      !row.callDetails?.callData?.recording_player
        ? "text-gray-400 cursor-not-allowed opacity-50"
        : "cursor-pointer"
    }`}
              onClick={(e) => {
                if (!row.callDetails?.callData?.recording_player) return; // prevent click
                e.stopPropagation();
                window.open(row.callDetails?.callData?.recording_player);
              }}
            ></i>

            {/* Edit Button */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                setSelectedRow(row);
                setIsModalOpenAcquisition(true);
              }}
              className="btn btn-sm btn-secondary"
              style={{
                padding: "3px 8px",
                backgroundColor: "#4CC9C0",
                border: "none",
              }}
            >
              ✏️
            </button>
          </div>
        );
      },
    },
  ];

  const handleCountInRevenue = (item: any, status: any, callback: any) => {
    countInRevenue(selectedClinic, item.appointmentId, {
      status: status,
    })
      .then((success) => {
        toast.success("Lead updated successfully");
        getData();
        callback();
      })
      .catch((error) => {
        toast.success("Lead update failed");
        callback();
      });
  };

  if (clinics?.length === 0) {
    return (
      <section className="middle-navbar px-30">
        <div className="p-0 container-fluid">
          <p>You do not have any clinics assigned, please contact your admin</p>
        </div>
      </section>
    );
  }
  console.log("callSummaryChart", callSummaryChart);
  return (
    <>
      <section className="middle-navbar py-4 px-30">
        <div className="p-0 container-fluid">
          <div className="d-flex justify-content-between align-items-start">
            <div>
              <div className="d-flex flex-row">
                <button
                  className="me-2"
                  onClick={() => {
                    let url = "/newdashboard?";
                    if (searchParams.get("clinic")) {
                      url += "clinic=" + searchParams.get("clinic");
                    }
                    if (searchParams.get("filter")) {
                      url += "&filter=" + searchParams.get("filter");
                    }
                    navigate(url);
                  }}
                >
                  <i className="bi bi-arrow-left"></i>
                </button>
                <div className="nav-title-txt m-0">Lead Analysis</div>
              </div>
            </div>

            <div className="d-flex flex-column">
              <div className="d-flex gap-3 align-items-center">
                <div className="dashb-filters">
                  <ReactDatePicker
                    className="form-control col-2"
                    selected={moment(dateFilter?.startDate).toDate()}
                    onChange={(date: any) => {
                      setDateFilter({
                        startDate: moment(date)
                          .startOf("month")
                          .format("YYYY-MM-DD"),
                        endDate: moment(date)
                          .endOf("month")
                          .format("YYYY-MM-DD"),
                      });
                    }}
                    showMonthYearPicker
                    dateFormat="MMM/yyyy"
                  />
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) => {
                      setSelectedQuater(e.target.value);
                      switch (e.target.value) {
                        case "thismonths":
                          setDateFilter({
                            startDate: moment()
                              .startOf("month")
                              .format("YYYY-MM-DD"),
                            endDate: moment().format("YYYY-MM-DD"),
                          });
                          break;
                        case "1months":
                          setDateFilter({
                            startDate: moment()
                              .subtract(1, "months")
                              .startOf("month")
                              .format("YYYY-MM-DD"),
                            endDate: moment()
                              .subtract(1, "months")
                              .endOf("month")
                              .format("YYYY-MM-DD"),
                          });
                          break;
                        case "3months":
                          setDateFilter({
                            startDate: moment()
                              .subtract(3, "months")
                              .startOf("month")
                              .format("YYYY-MM-DD"),
                            endDate: moment()
                              .subtract(1, "months")
                              .endOf("month")
                              .format("YYYY-MM-DD"),
                          });
                          break;
                        case "6months":
                          setDateFilter({
                            startDate: moment()
                              .subtract(6, "months")
                              .startOf("month")
                              .format("YYYY-MM-DD"),
                            endDate: moment()
                              .subtract(1, "months")
                              .endOf("month")
                              .format("YYYY-MM-DD"),
                          });
                          break;
                        case "9months":
                          setDateFilter({
                            startDate: moment()
                              .subtract(9, "months")
                              .startOf("month")
                              .format("YYYY-MM-DD"),
                            endDate: moment()
                              .subtract(1, "months")
                              .endOf("month")
                              .format("YYYY-MM-DD"),
                          });
                          break;
                        case "12months":
                          setDateFilter({
                            startDate: moment()
                              .subtract(12, "months")
                              .startOf("month")
                              .format("YYYY-MM-DD"),
                            endDate: moment()
                              .subtract(1, "months")
                              .endOf("month")
                              .format("YYYY-MM-DD"),
                          });
                          break;
                      }
                    }}
                    value={selectedQuater}
                  >
                    <option value="thismonths">This Month</option>
                    <option value="1months">Last Month</option>
                    <option value="3months">Last 3 Months</option>
                    <option value="6months">Last 6 Months</option>
                    <option value="9months">Last 9 Months</option>
                    <option value="12months">Last 12 Months</option>
                  </select>
                </div>
                <div>
                  <RangePicker
                    className="pdf-download-button h-[38px] rounded-[10px] w-[240px]"
                    dropdownClassName="single-calendar"
                    getPopupContainer={(trigger) => trigger.parentElement!}
                    value={
                      lastUsedDatePicker === "range"
                        ? [
                            moment(dateFilter.startDate),
                            moment(dateFilter.endDate),
                          ]
                        : null
                    }
                    onChange={(dates: any) => {
                      if (dates && dates[0] && dates[1]) {
                        setLastUsedDatePicker("range");
                        setDateFilter({
                          startDate: dates[0].format("YYYY-MM-DD"),
                          endDate: dates[1].format("YYYY-MM-DD"),
                        });
                      }
                    }}
                  />
                </div>

                <select
                  className="form-select"
                  aria-label="Default select example"
                  value={selectedClinic}
                  onChange={(e) => {
                    setSelectedClinic(e.target.value);
                  }}
                >
                  {clinics?.map((item: any) => {
                    return <option value={item.uniqueId}>{item.name}</option>;
                  })}
                </select>

                {user?.role !== "Read Only" && (
                  <div>
                    <button
                      onClick={() => {
                        navigate("/api-connection");
                      }}
                    >
                      <i className="bi bi-gear"></i>
                    </button>
                  </div>
                )}
              </div>
              <small className="pt-1 text-success">
                From {dateFilter?.startDate} to {dateFilter?.endDate}
              </small>
            </div>
          </div>
        </div>
      </section>

      <section className="matrix px-30 pt-5">
        <div className="container">
          <div className="row">
            <div className="col-3">
              <div className="card result-card">
                <div className="cardtop">
                  <div className="cardtop_title">Missed calls</div>
                  <div className="cardtop_number">
                    {callSummaryData?.total_results?.missed_calls ?? 0}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="card result-card">
                <div className="cardtop">
                  <div className="cardtop_title">Answered calls</div>
                  <div className="cardtop_number">
                    {callSummaryData?.total_results?.answered_calls ?? 0}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="card result-card">
                <div className="cardtop">
                  <div className="cardtop_title">First time callers</div>
                  <div className="cardtop_number">
                    {callSummaryData?.total_results?.first_time_callers ?? 0}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-3">
                            <div className="card result-card">
                                <div className="cardtop">
                                    <div className="cardtop_title">Average duration</div>
                                    <div className="cardtop_number">{callSummaryData?.total_results?.average_duration ?? 0}</div>
                                </div>
                            </div>
                        </div> */}
            <div className="col-3">
              <div className="card result-card">
                <div className="cardtop">
                  <div className="cardtop_title">Average duration</div>
                  <div className="cardtop_number">
                    {callSummaryData?.total_results
                      ?.formatted_average_duration ?? "-"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="graphs px-30 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-12 pt-5">
              <div className="card reviews-section">
                <div className="card-header d-flex justify-content-between align-items-center py-3">
                  <h6 className="m-0">Call Summary day wise</h6>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-2">
                      <div className="avg-reviewbox">
                        <div className="avg-title text-white">Total Calls</div>
                        <div className="avg-rating text-white">
                          {callSummaryData?.total_results?.total_calls ?? 0}
                        </div>
                      </div>
                      <div className="total-callleadbox">
                        <div className="avg-title text-white">Leads</div>
                        <div className="avg-rating text-white">
                          {callSummaryData?.totalCallLeads ?? 0}
                        </div>
                      </div>
                    </div>
                    <div className="col w-100">
                      <div
                        className="graph-layout"
                        style={{ width: "100%", height: "300px" }}
                      >
                        {callSummaryChart?.data?.labels?.length > 0 &&
                          callSummaryChart?.data?.datasets?.length && (
                            <Bar
                              width={"100%"}
                              options={callSummaryChart?.options}
                              data={callSummaryChart?.data}
                            />
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="px-30 pb-5 pt-5">
        <div className="container">
          <div className="row">
            <div className="col-12 mb-5">
              <Tabs
                defaultActiveKey="profile"
                id="uncontrolled-tab-example"
                className="mb-3"
              >
                <Tab eventKey="profile" title="Online Leads">
                  <div className="card reviews-section">
                    <div className="card-header d-flex justify-content-between align-items-center py-3">
                      <h6 className="m-0">Online Leads</h6>
                    </div>
                    <div className="client-table-details-sec card-body">
                      <div className="row">
                        <Table
                          className="p-0"
                          columns={acquisitionscolumns}
                          dataSource={acquisitionsListTableMapped}
                          pagination={{ defaultPageSize: 50 }}
                          onRow={(record) => {
                            return {
                              style: {
                                backgroundColor:
                                  record?.type === "New Patient"
                                    ? "#e6f7e6"
                                    : undefined,
                              },
                            };
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="callleads" title="Call Leads">
                  <div className="card reviews-section">
                    <div className="card-header d-flex justify-content-between align-items-center py-3">
                      <h6 className="m-0">Call Leads</h6>
                    </div>
                    <div className="client-table-details-sec card-body">
                      <div className="row">
                        <CallTable
                          setTags={setTags}
                          setSummary={setSummary}
                          setTranscript={setTranscript}
                          isModalVisible={isModalVisible}
                          setIsModalVisible={setIsModalVisible}
                          data={callRailCallDetailsTable?.map((item: any) => ({
                            ...item,
                            status:
                              item?.verified === 1 || item?.verified === "1"
                                ? "Auto Matched"
                                : item?.status ?? "",
                          }))}
                          selectedClinic={selectedClinic}
                          refetch={() => {
                            getData();
                          }}
                          patientList={callRailCallDetailsTablePL}
                        ></CallTable>
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="opportunitylost" title="Opportunity Lost">
                  <div className="card reviews-section">
                    <div className="card-header d-flex justify-content-between align-items-center py-3">
                      <h6 className="m-0">Opportunity Lost</h6>
                    </div>
                    <div className="client-table-details-sec card-body">
                      <div className="row">
                        <CallTableOpportunityLost
                          data={callRailCallDetailsOLTable?.map(
                            (item: any) => ({
                              ...item,
                              status:
                                item?.verified === 1 || item?.verified === "1"
                                  ? "Auto Matched"
                                  : item.status,
                            })
                          )}
                          selectedClinic={selectedClinic}
                          refetch={() => {
                            getData();
                          }}
                          patientList={callRailCallDetailsOLTablePL}
                        ></CallTableOpportunityLost>
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="acquisitions" title="Acquisitions">
                  <div className="card reviews-section">
                    <div className="card-header d-flex justify-content-between align-items-center py-3">
                      <h6 className="m-0">Acquisitions</h6>
                    </div>
                    <div className="client-table-details-sec card-body">
                      <div className="row">
                        <AcquisitionsTable
                          data={newAcquisitions}
                          columns={acquisitionsColumns}
                        />
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="home" title="Revenue">
                  <div className="card reviews-section">
                    <div className="card-header d-flex justify-content-between align-items-center py-3">
                      <h6 className="m-0">Revenue</h6>
                    </div>
                    <div className="client-table-details-sec card-body">
                      <div className="row">
                        <Table
                          className="p-0"
                          columns={columns}
                          dataSource={leadListTableMapped}
                          pagination={{ defaultPageSize: 50 }}
                        />
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </section>
      <InfoModal
        open={isInfoModalOpen}
        onClose={() => setIsInfoModalOpen(false)}
        data={infoRowData}
      />

      <UpdateOnlineLeads
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        clinicData={clinicData}
        dateFilter={dateFilter}
        initialData={selectedRow}
        onSave={getData}
      />
      <UpdateAcquisition
        open={isModalOpenAcquisition}
        onClose={() => setIsModalOpenAcquisition(false)}
        clinicData={clinicData}
        dateFilter={dateFilter}
        initialData={selectedRow}
        onSave={getData}
      />
      <CustomDialog
        isOpen={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        title="View Summary"
        tabs={[
          {
            key: "summary",
            title: "Summary & Highlights",
            content: (
              <div className="space-y-3">
                <h3 className="text-lg font-medium text-gray-900">
                  Highlights
                </h3>
                <div className="flex flex-wrap gap-2">
                  {tags?.length > 0 ? (
                    tags.map((tag: string, index: number) => (
                      <span
                        key={index}
                        className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors duration-200"
                      >
                        {tag.charAt(0).toUpperCase() +
                          tag.slice(1).toLowerCase()}
                      </span>
                    ))
                  ) : (
                    <p className="text-gray-500 italic">
                      No highlights available
                    </p>
                  )}
                </div>
                <h3 className="text-lg font-medium text-gray-900">Summary</h3>
                <div className="flex flex-wrap gap-2">
                  {summary?.length > 0 ? (
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors duration-200">
                      {summary}
                    </span>
                  ) : (
                    <p className="text-gray-500 italic">No summary available</p>
                  )}
                </div>
              </div>
            ),
          },
          // {
          //   key: "highlights",
          //   title: "Highlights",
          //   content: <div>Highlights content here</div>,
          // },
          {
            key: "transcription",
            title: "Transcription",
            content: (
              <div className="flex flex-col h-full">
                {/* <h2 className="text-lg font-semibold mb-3 text-gray-800">
                  Chat Transcript
                </h2> */}
                <div className="flex-1 overflow-y-auto space-y-2 pr-2">
                  {transcript?.length > 0 ? (
                    transcript?.map((msg: any, index: number) => (
                      <div
                        key={index}
                        className={`flex ${
                          msg?.speaker === "Agent"
                            ? "justify-start"
                            : "justify-end"
                        }`}
                      >
                        <div
                          className={`rounded-lg px-2 pt-2 max-w-[80%] ${
                            msg?.speaker === "Agent"
                              ? "bg-blue-50 border border-blue-100"
                              : "bg-green-50 border border-green-100"
                          }`}
                        >
                          <p className="text-xs font-medium text-gray-500 mb-1">
                            {msg?.speaker}
                            {/* {new Date(msg.timestamp).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          })} */}
                          </p>
                          <p className="text-sm text-gray-800 leading-tight">
                            {msg.text}
                          </p>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No transcript available</p>
                  )}
                </div>
              </div>
            ),
          },
        ]}
        maxWidth="md"
      />
    </>
  );
};

export const CallTable = ({
  data,
  selectedClinic,
  refetch,
  patientList,
  isModalVisible,
  setIsModalVisible,
  setTranscript,
  setTags,
  setSummary,
}: any) => {
  const [openSyncModal, setOpenSyncModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  function parseTranscript(transcript: string): any[] {
    const pattern = /(Agent|Caller):/g;

    const parts = transcript?.split(pattern)?.filter(Boolean);

    const messages: any[] = [];

    for (let i = 0; i < parts?.length; i += 2) {
      const speaker = parts[i]?.trim();
      const text = (parts[i + 1] || "").trim();

      if (speaker === "Agent" || speaker === "Caller") {
        messages.push({ speaker, text });
      }
    }

    return messages;
  }
  function splitCommaValues(input: string): string[] {
    return input
      ?.split(",")
      ?.map((word) => word?.trim()?.toLowerCase())
      ?.filter(Boolean);
  }

  const columns: any = [
    {
      title: "Source",
      dataIndex: "source",
      sorter: (a: any, b: any) => a.source.localeCompare(b.source),
      render: (text: any, row: any) => {
        text = text ? text?.toLowerCase() : text;
        if (text === "onlinescheduling") {
          return (
            <img
              src={require("../../assets/images/xcare-api-icon.png")}
              width={14}
              height={14}
            ></img>
          );
        } else if (text === "google-mail") {
          return <i className="bi bi-envelope"></i>;
        } else if (text === "facebook") {
          return <i className="bi bi-facebook"></i>;
        } else if (text === "offer-mail") {
          return <i className="bi bi-coin"></i>;
        } else if (text === "google") {
          return <i className="bi bi-google"></i>;
        } else if (text === "instagram") {
          return <i className="bi bi-instagram"></i>;
        } else if (text?.includes("email")) {
          return <i className="bi bi-envelope"></i>;
        } else if (text === "paid ads") {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="12"
              height="12"
              viewBox="0 -13 256 256"
              version="1.1"
            >
              <g>
                <path
                  d="M5.888,166.405103 L90.88,20.9 C101.676138,27.2558621 156.115862,57.3844138 164.908138,63.1135172 L79.9161379,208.627448 C70.6206897,220.906621 -5.888,185.040138 5.888,166.396276 L5.888,166.405103 Z"
                  fill="#FBBC04"
                ></path>
                <path
                  d="M250.084224,166.401789 L165.092224,20.9055131 C153.210293,1.13172 127.619121,-6.05393517 106.600638,5.62496138 C85.582155,17.3038579 79.182155,42.4624786 91.0640861,63.1190303 L176.056086,208.632961 C187.938017,228.397927 213.52919,235.583582 234.547672,223.904686 C254.648086,212.225789 261.966155,186.175582 250.084224,166.419444 L250.084224,166.401789 Z"
                  fill="#4285F4"
                ></path>
                <ellipse
                  fill="#34A853"
                  cx="42.6637241"
                  cy="187.924414"
                  rx="42.6637241"
                  ry="41.6044138"
                ></ellipse>
              </g>
            </svg>
          );
        } else if (text === "google-ads") {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="12"
              height="12"
              viewBox="0 -13 256 256"
              version="1.1"
            >
              <g>
                <path
                  d="M5.888,166.405103 L90.88,20.9 C101.676138,27.2558621 156.115862,57.3844138 164.908138,63.1135172 L79.9161379,208.627448 C70.6206897,220.906621 -5.888,185.040138 5.888,166.396276 L5.888,166.405103 Z"
                  fill="#FBBC04"
                ></path>
                <path
                  d="M250.084224,166.401789 L165.092224,20.9055131 C153.210293,1.13172 127.619121,-6.05393517 106.600638,5.62496138 C85.582155,17.3038579 79.182155,42.4624786 91.0640861,63.1190303 L176.056086,208.632961 C187.938017,228.397927 213.52919,235.583582 234.547672,223.904686 C254.648086,212.225789 261.966155,186.175582 250.084224,166.419444 L250.084224,166.401789 Z"
                  fill="#4285F4"
                ></path>
                <ellipse
                  fill="#34A853"
                  cx="42.6637241"
                  cy="187.924414"
                  rx="42.6637241"
                  ry="41.6044138"
                ></ellipse>
              </g>
            </svg>
          );
        } else if (text === "organic") {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="12"
              width="12"
              viewBox="0 0.43 1064 928.69"
            >
              <linearGradient
                id="a"
                x1="0%"
                x2="99.999%"
                y1="49.999%"
                y2="49.999%"
              >
                <stop offset=".03" stop-color="#4079d8" />
                <stop offset="1" stop-color="#4989f5" />
              </linearGradient>
              <g fill="none" fill-rule="evenodd">
                <g fill-rule="nonzero">
                  <rect
                    fill="#4989f5"
                    height="696.14"
                    rx="36.88"
                    width="931"
                    x="53.45"
                    y="232.98"
                  />
                  <path
                    d="M936.81 227.75H100.06c-25.92 0-46.09 200.6-46.09 226.52L512.2 929.12h424.61c26-.071 47.059-21.13 47.13-47.13V274.87c-.077-25.996-21.134-47.049-47.13-47.12z"
                    fill="url(#a)"
                  />
                  <path d="M266.03 349.56h266V.44H305.86z" fill="#3c4ba6" />
                  <path
                    d="M798.03 349.56h-266V.44H758.2zM984.45 66.62l.33 1.19c-.08-.42-.24-.81-.33-1.19z"
                    fill="#7babf7"
                  />
                  <path
                    d="M984.78 67.8l-.33-1.19C976.017 27.993 941.837.455 902.31.43H758.2L798 349.56h266z"
                    fill="#3f51b5"
                  />
                  <path
                    d="M79.61 66.62l-.33 1.19c.08-.42.24-.81.33-1.19z"
                    fill="#7babf7"
                  />
                  <path
                    d="M79.27 67.8l.33-1.19C88.033 27.993 122.213.455 161.74.43h144.12L266 349.56H0z"
                    fill="#7babf7"
                  />
                </g>
                <path
                  d="M266.48 349.47c0 73.412-59.513 132.925-132.925 132.925S.63 422.882.63 349.47z"
                  fill="#709be0"
                />
                <path
                  d="M532.33 349.47c0 73.412-59.513 132.925-132.925 132.925S266.48 422.882 266.48 349.47z"
                  fill="#3c4ba6"
                />
                <path
                  d="M798.18 349.47c0 73.412-59.513 132.925-132.925 132.925S532.33 422.882 532.33 349.47z"
                  fill="#709be0"
                />
                <path
                  d="M1064 349.47c0 73.412-59.513 132.925-132.925 132.925S798.15 422.882 798.15 349.47z"
                  fill="#3c4ba6"
                />
                <path
                  d="M931.08 709.6c-.47-6.33-1.25-12.11-2.36-19.49h-145c0 20.28 0 42.41-.08 62.7h84a73.05 73.05 0 0 1-30.75 46.89s0-.35-.06-.36a88 88 0 0 1-34 13.27 99.85 99.85 0 0 1-36.79-.16 91.9 91.9 0 0 1-34.31-14.87 95.72 95.72 0 0 1-33.73-43.1c-.52-1.35-1-2.71-1.49-4.09v-.15l.13-.1a93 93 0 0 1-.05-59.84A96.27 96.27 0 0 1 718.9 654c23.587-24.399 58.829-33.576 91.32-23.78a83 83 0 0 1 33.23 19.56l28.34-28.34c5-5.05 10.19-9.94 15-15.16a149.78 149.78 0 0 0-49.64-30.74 156.08 156.08 0 0 0-103.83-.91c-1.173.4-2.34.817-3.5 1.25A155.18 155.18 0 0 0 646 651a152.61 152.61 0 0 0-13.42 38.78c-16.052 79.772 32.623 158.294 111.21 179.4 25.69 6.88 53 6.71 78.89.83a139.88 139.88 0 0 0 63.14-32.81c18.64-17.15 32-40 39-64.27a179 179 0 0 0 6.26-63.33z"
                  fill="#fff"
                  fill-rule="nonzero"
                />
              </g>
            </svg>
          );
        } else if (text === "gmb") {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="12"
              width="12"
              viewBox="0 0.43 1064 928.69"
            >
              <linearGradient
                id="a"
                x1="0%"
                x2="99.999%"
                y1="49.999%"
                y2="49.999%"
              >
                <stop offset=".03" stop-color="#4079d8" />
                <stop offset="1" stop-color="#4989f5" />
              </linearGradient>
              <g fill="none" fill-rule="evenodd">
                <g fill-rule="nonzero">
                  <rect
                    fill="#4989f5"
                    height="696.14"
                    rx="36.88"
                    width="931"
                    x="53.45"
                    y="232.98"
                  />
                  <path
                    d="M936.81 227.75H100.06c-25.92 0-46.09 200.6-46.09 226.52L512.2 929.12h424.61c26-.071 47.059-21.13 47.13-47.13V274.87c-.077-25.996-21.134-47.049-47.13-47.12z"
                    fill="url(#a)"
                  />
                  <path d="M266.03 349.56h266V.44H305.86z" fill="#3c4ba6" />
                  <path
                    d="M798.03 349.56h-266V.44H758.2zM984.45 66.62l.33 1.19c-.08-.42-.24-.81-.33-1.19z"
                    fill="#7babf7"
                  />
                  <path
                    d="M984.78 67.8l-.33-1.19C976.017 27.993 941.837.455 902.31.43H758.2L798 349.56h266z"
                    fill="#3f51b5"
                  />
                  <path
                    d="M79.61 66.62l-.33 1.19c.08-.42.24-.81.33-1.19z"
                    fill="#7babf7"
                  />
                  <path
                    d="M79.27 67.8l.33-1.19C88.033 27.993 122.213.455 161.74.43h144.12L266 349.56H0z"
                    fill="#7babf7"
                  />
                </g>
                <path
                  d="M266.48 349.47c0 73.412-59.513 132.925-132.925 132.925S.63 422.882.63 349.47z"
                  fill="#709be0"
                />
                <path
                  d="M532.33 349.47c0 73.412-59.513 132.925-132.925 132.925S266.48 422.882 266.48 349.47z"
                  fill="#3c4ba6"
                />
                <path
                  d="M798.18 349.47c0 73.412-59.513 132.925-132.925 132.925S532.33 422.882 532.33 349.47z"
                  fill="#709be0"
                />
                <path
                  d="M1064 349.47c0 73.412-59.513 132.925-132.925 132.925S798.15 422.882 798.15 349.47z"
                  fill="#3c4ba6"
                />
                <path
                  d="M931.08 709.6c-.47-6.33-1.25-12.11-2.36-19.49h-145c0 20.28 0 42.41-.08 62.7h84a73.05 73.05 0 0 1-30.75 46.89s0-.35-.06-.36a88 88 0 0 1-34 13.27 99.85 99.85 0 0 1-36.79-.16 91.9 91.9 0 0 1-34.31-14.87 95.72 95.72 0 0 1-33.73-43.1c-.52-1.35-1-2.71-1.49-4.09v-.15l.13-.1a93 93 0 0 1-.05-59.84A96.27 96.27 0 0 1 718.9 654c23.587-24.399 58.829-33.576 91.32-23.78a83 83 0 0 1 33.23 19.56l28.34-28.34c5-5.05 10.19-9.94 15-15.16a149.78 149.78 0 0 0-49.64-30.74 156.08 156.08 0 0 0-103.83-.91c-1.173.4-2.34.817-3.5 1.25A155.18 155.18 0 0 0 646 651a152.61 152.61 0 0 0-13.42 38.78c-16.052 79.772 32.623 158.294 111.21 179.4 25.69 6.88 53 6.71 78.89.83a139.88 139.88 0 0 0 63.14-32.81c18.64-17.15 32-40 39-64.27a179 179 0 0 0 6.26-63.33z"
                  fill="#fff"
                  fill-rule="nonzero"
                />
              </g>
            </svg>
          );
        } else if (text === "seo") {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              fill="#000000"
              height="14"
              width="14"
              version="1.1"
              id="Layer_1"
              viewBox="0 0 512 512"
              xmlSpace="preserve"
            >
              <g>
                <g>
                  <g>
                    <path d="M497.453,241.022l-43.995-114.147l43.984-113.132c1.207-3.104,0.805-6.603-1.077-9.352C494.485,1.644,491.37,0,488.039,0     H23.961c-5.571,0-10.089,4.517-10.089,10.089v491.823c0,5.571,4.517,10.089,10.089,10.089h50.443     c5.571,0,10.089-4.517,10.089-10.089V254.739h403.547c3.325,0,6.437-1.638,8.318-4.381     C498.239,247.618,498.649,244.124,497.453,241.022z M64.315,491.823H34.049V20.177h30.266V491.823z M84.493,234.562V20.177     h388.801l-40.056,103.025c-0.912,2.342-0.916,4.94-0.011,7.284l40.113,104.075H84.493z" />
                    <path d="M135.566,66.837h47.291c5.571,0,10.089-4.517,10.089-10.089s-4.517-10.089-10.089-10.089h-47.291     c-18.427,0-33.419,14.992-33.419,33.419v23.961c0,18.427,14.992,33.419,33.419,33.419c0.537,0,1.062-0.054,1.576-0.135     c0.514,0.081,1.039,0.135,1.576,0.135h20.808c7.302,0,13.241,5.94,13.241,13.241v23.961c0,7.302-5.94,13.241-13.241,13.241     h-47.291c-5.571,0-10.089,4.517-10.089,10.089c0,5.571,4.517,10.089,10.089,10.089h47.291c18.427,0,33.419-14.992,33.419-33.419     V150.7c0-18.427-14.992-33.419-33.419-33.419h-20.808c-0.537,0-1.062,0.054-1.576,0.135c-0.515-0.081-1.039-0.135-1.576-0.135     c-7.302,0-13.241-5.94-13.241-13.241V80.079C122.325,72.777,128.265,66.837,135.566,66.837z" />
                    <path d="M246.542,66.837h47.291c5.571,0,10.089-4.517,10.089-10.089s-4.517-10.089-10.089-10.089h-47.291     c-18.427,0-33.419,14.992-33.419,33.419v47.291v47.291c0,18.427,14.992,33.419,33.419,33.419h47.291     c5.571,0,10.089-4.517,10.089-10.089c0-5.571-4.517-10.089-10.089-10.089h-47.291c-7.302,0-13.241-5.94-13.241-13.241v-37.202     h60.532c5.571,0,10.089-4.517,10.089-10.089s-4.517-10.089-10.089-10.089H233.3V80.079     C233.3,72.777,239.24,66.837,246.542,66.837z" />
                    <path d="M381.478,46.66h-23.961c-18.427,0-33.419,14.992-33.419,33.419v94.581c0,18.427,14.992,33.419,33.419,33.419h23.961     c18.427,0,33.419-14.992,33.419-33.419V80.079C414.896,61.652,399.905,46.66,381.478,46.66z M394.719,174.66     c0,7.302-5.94,13.241-13.241,13.241h-23.961c-7.302,0-13.241-5.94-13.241-13.241V80.079c0-7.302,5.94-13.241,13.241-13.241     h23.961c7.302,0,13.241,5.94,13.241,13.241V174.66z" />
                    <path d="M316.532,293.833c0-5.571-4.517-10.089-10.089-10.089h-186.64c-5.571,0-10.089,4.517-10.089,10.089     s4.517,10.089,10.089,10.089h186.64C312.015,303.921,316.532,299.404,316.532,293.833z" />
                    <path d="M479.212,324.099H296.355c-5.571,0-10.089,4.517-10.089,10.089s4.517,10.089,10.089,10.089h182.857     c5.571,0,10.089-4.517,10.089-10.089S484.783,324.099,479.212,324.099z" />
                  </g>
                </g>
              </g>
            </svg>
          );
        } else if (text === "meta-ads") {
          return <i className="bi bi-meta"></i>;
        }
        return (
          <>
            <img
              src={require("../../assets/images/xcare-api-icon.png")}
              width={14}
              height={14}
            ></img>
          </>
        );
      },
    },
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a: any, b: any) =>
        moment(a?.callData?.start_time).unix() -
        moment(b?.callData?.start_time).unix(),
      render: (text: any, row: any) => (
        <p>
          {moment.parseZone(row.callData?.start_time).format("YYYY-MM-DD LT")}
        </p>
      ),
      width: "200px",
    },
    {
      title: "Contact",
      sorter: (a: any, b: any) =>
        a.customerNumber.localeCompare(b.customerNumber),
      dataIndex: "customerNumber",
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
      render: (text: any, row: any) => {
        return <div className="d-flex">{row?.status}</div>;
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text: any, row: any) => {
        return (
          <div className="d-flex gap-2 items-center">
            {row?.recording && row?.callData?.recording_player && (
              <i
                className="bi bi-play-fill"
                onClick={() => {
                  window.open(row.callData.recording_player);
                }}
              ></i>
            )}
            {row?.verified === 1 || row?.verified === "1" ? null : (
              <StatusChange
                item={row}
                selectedClinic={selectedClinic}
                refetch={() => {
                  refetch();
                }}
                selectedRow={selectedRow}
                patientList={patientList}
                openSyncModal={openSyncModal}
                setOpenSyncModal={setOpenSyncModal}
              ></StatusChange>
            )}
            <button
              onClick={() => {
                setOpenSyncModal(true);
                setSelectedRow(row);
              }}
            >
              <i className="bi bi-arrow-repeat"></i>
            </button>
            {/* <SyncLead
              item={row}
              selectedClinic={selectedClinic}
              refetch={() => {
                refetch();
              }}
              patientList={patientList}
            ></SyncLead> */}
            <Note
              item={row}
              selectedClinic={selectedClinic}
              refetch={() => {
                refetch();
              }}
            ></Note>
          </div>
        );
      },
    },
    {
      title: "Note",
      dataIndex: "notes",
      render: (text: any, row: any) => (
        <OverlayTrigger
          placement="auto"
          overlay={<BSTooltip id="tooltip">{text}</BSTooltip>}
        >
          <p>
            {row.notes.substring(0, 50)}
            {row.notes.length > 50 ? "..." : ""}
          </p>
        </OverlayTrigger>
      ),
    },
    {
      title: "Metadata",
      dataIndex: "metadata",
      render: (text: any, row: any) => (
        <div className="flex gap-2">
          <OverlayTrigger
            placement="auto"
            overlay={
              <BSTooltip id="tooltip">
                {row.firstTime ? "First time caller" : "Called more than once"}
              </BSTooltip>
            }
          >
            {row.firstTime ? (
              <i className="bi bi-megaphone text-success"></i>
            ) : (
              <i className="bi bi-megaphone-fill text-warning"></i>
            )}
          </OverlayTrigger>
          <OverlayTrigger
            placement="auto"
            overlay={
              <BSTooltip id="tooltip">
                {row.missed ? "Call missed" : "Called attended"}
              </BSTooltip>
            }
          >
            {row.missed ? (
              <i className="bi bi-telephone-x-fill text-danger"></i>
            ) : (
              <i className="bi bi-telephone-fill text-success"></i>
            )}
          </OverlayTrigger>
          <div
            onClick={() => {
              const parsedTranscript = parseTranscript(row?.transcription);
              const tags = splitCommaValues(row?.highlights);
              const summary = row?.summary;
              setTranscript(parsedTranscript ?? []);
              setTags(tags ?? []);
              setSummary(summary ?? []);
              setIsModalVisible(true);
            }}
          >
            <OverlayTrigger
              placement="top"
              overlay={<BSTooltip>View call summary</BSTooltip>}
            >
              <i
                className="bi bi-journal-text ms-2 text-primary"
                style={{ cursor: "pointer" }}
              ></i>
            </OverlayTrigger>
          </div>
        </div>
      ),
    },
    // {
    //   title: "Summary",
    //   key: "actions",
    //   width: "140px",
    //   render: (_: any, row: any) => {
    //     return (
    //       <>
    //         <span
    //           className="text-sm text-primary cursor-pointer border border-[#194e5b] p-[4px] rounded-md"
    //           onClick={() => {
    //             const parsedTranscript = parseTranscript(row.transcription);
    //             const tags = splitCommaValues(row.highlights);
    //             const summary = row.summary;
    //             setTranscript(parsedTranscript);
    //             setTags(tags);
    //             setSummary(summary);
    //             setIsModalVisible(true);
    //           }}
    //         >
    //           View Summary
    //         </span>
    //       </>
    //     );
    //   },
    // },
  ];

  const mappedData = useMemo(() => {
    return data?.map((item: any) => {
      return {
        ...item,
      };
    });
  }, [data]);

  return (
    <>
      <Table
        className="p-0"
        columns={columns}
        dataSource={mappedData}
        pagination={{
          defaultPageSize: 50,
        }}
      />
      <SyncLead
        open={openSyncModal}
        onClose={() => setOpenSyncModal(false)}
        item={selectedRow}
        selectedClinic={selectedClinic}
        refetch={refetch}
        patientList={patientList}
      />
    </>
  );
};

export const CallTableOpportunityLost = ({
  data,
  selectedClinic,
  refetch,
  patientList,
}: any) => {
  console.log(selectedClinic, "selectedClinic");
  const columns: any = [
    {
      title: "Source",
      dataIndex: "source",
      sorter: (a: any, b: any) => a.source.localeCompare(b.source),
      render: (text: any, row: any) => {
        text = text ? text?.toLowerCase() : text;
        if (text === "onlinescheduling") {
          return (
            <img
              src={require("../../assets/images/xcare-api-icon.png")}
              width={14}
              height={14}
            ></img>
          );
        } else if (text === "google-mail") {
          return <i className="bi bi-envelope"></i>;
        } else if (text === "facebook") {
          return <i className="bi bi-facebook"></i>;
        } else if (text === "offer-mail") {
          return <i className="bi bi-coin"></i>;
        } else if (text === "google") {
          return <i className="bi bi-google"></i>;
        } else if (text === "instagram") {
          return <i className="bi bi-instagram"></i>;
        } else if (text?.includes("email")) {
          return <i className="bi bi-envelope"></i>;
        } else if (text === "google-ads") {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="12"
              height="12"
              viewBox="0 -13 256 256"
              version="1.1"
            >
              <g>
                <path
                  d="M5.888,166.405103 L90.88,20.9 C101.676138,27.2558621 156.115862,57.3844138 164.908138,63.1135172 L79.9161379,208.627448 C70.6206897,220.906621 -5.888,185.040138 5.888,166.396276 L5.888,166.405103 Z"
                  fill="#FBBC04"
                ></path>
                <path
                  d="M250.084224,166.401789 L165.092224,20.9055131 C153.210293,1.13172 127.619121,-6.05393517 106.600638,5.62496138 C85.582155,17.3038579 79.182155,42.4624786 91.0640861,63.1190303 L176.056086,208.632961 C187.938017,228.397927 213.52919,235.583582 234.547672,223.904686 C254.648086,212.225789 261.966155,186.175582 250.084224,166.419444 L250.084224,166.401789 Z"
                  fill="#4285F4"
                ></path>
                <ellipse
                  fill="#34A853"
                  cx="42.6637241"
                  cy="187.924414"
                  rx="42.6637241"
                  ry="41.6044138"
                ></ellipse>
              </g>
            </svg>
          );
        } else if (text === "gmb") {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="12"
              width="12"
              viewBox="0 0.43 1064 928.69"
            >
              <linearGradient
                id="a"
                x1="0%"
                x2="99.999%"
                y1="49.999%"
                y2="49.999%"
              >
                <stop offset=".03" stop-color="#4079d8" />
                <stop offset="1" stop-color="#4989f5" />
              </linearGradient>
              <g fill="none" fill-rule="evenodd">
                <g fill-rule="nonzero">
                  <rect
                    fill="#4989f5"
                    height="696.14"
                    rx="36.88"
                    width="931"
                    x="53.45"
                    y="232.98"
                  />
                  <path
                    d="M936.81 227.75H100.06c-25.92 0-46.09 200.6-46.09 226.52L512.2 929.12h424.61c26-.071 47.059-21.13 47.13-47.13V274.87c-.077-25.996-21.134-47.049-47.13-47.12z"
                    fill="url(#a)"
                  />
                  <path d="M266.03 349.56h266V.44H305.86z" fill="#3c4ba6" />
                  <path
                    d="M798.03 349.56h-266V.44H758.2zM984.45 66.62l.33 1.19c-.08-.42-.24-.81-.33-1.19z"
                    fill="#7babf7"
                  />
                  <path
                    d="M984.78 67.8l-.33-1.19C976.017 27.993 941.837.455 902.31.43H758.2L798 349.56h266z"
                    fill="#3f51b5"
                  />
                  <path
                    d="M79.61 66.62l-.33 1.19c.08-.42.24-.81.33-1.19z"
                    fill="#7babf7"
                  />
                  <path
                    d="M79.27 67.8l.33-1.19C88.033 27.993 122.213.455 161.74.43h144.12L266 349.56H0z"
                    fill="#7babf7"
                  />
                </g>
                <path
                  d="M266.48 349.47c0 73.412-59.513 132.925-132.925 132.925S.63 422.882.63 349.47z"
                  fill="#709be0"
                />
                <path
                  d="M532.33 349.47c0 73.412-59.513 132.925-132.925 132.925S266.48 422.882 266.48 349.47z"
                  fill="#3c4ba6"
                />
                <path
                  d="M798.18 349.47c0 73.412-59.513 132.925-132.925 132.925S532.33 422.882 532.33 349.47z"
                  fill="#709be0"
                />
                <path
                  d="M1064 349.47c0 73.412-59.513 132.925-132.925 132.925S798.15 422.882 798.15 349.47z"
                  fill="#3c4ba6"
                />
                <path
                  d="M931.08 709.6c-.47-6.33-1.25-12.11-2.36-19.49h-145c0 20.28 0 42.41-.08 62.7h84a73.05 73.05 0 0 1-30.75 46.89s0-.35-.06-.36a88 88 0 0 1-34 13.27 99.85 99.85 0 0 1-36.79-.16 91.9 91.9 0 0 1-34.31-14.87 95.72 95.72 0 0 1-33.73-43.1c-.52-1.35-1-2.71-1.49-4.09v-.15l.13-.1a93 93 0 0 1-.05-59.84A96.27 96.27 0 0 1 718.9 654c23.587-24.399 58.829-33.576 91.32-23.78a83 83 0 0 1 33.23 19.56l28.34-28.34c5-5.05 10.19-9.94 15-15.16a149.78 149.78 0 0 0-49.64-30.74 156.08 156.08 0 0 0-103.83-.91c-1.173.4-2.34.817-3.5 1.25A155.18 155.18 0 0 0 646 651a152.61 152.61 0 0 0-13.42 38.78c-16.052 79.772 32.623 158.294 111.21 179.4 25.69 6.88 53 6.71 78.89.83a139.88 139.88 0 0 0 63.14-32.81c18.64-17.15 32-40 39-64.27a179 179 0 0 0 6.26-63.33z"
                  fill="#fff"
                  fill-rule="nonzero"
                />
              </g>
            </svg>
          );
        } else if (text === "seo") {
          return (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              fill="#000000"
              height="14"
              width="14"
              version="1.1"
              id="Layer_1"
              viewBox="0 0 512 512"
              xmlSpace="preserve"
            >
              <g>
                <g>
                  <g>
                    <path d="M497.453,241.022l-43.995-114.147l43.984-113.132c1.207-3.104,0.805-6.603-1.077-9.352C494.485,1.644,491.37,0,488.039,0     H23.961c-5.571,0-10.089,4.517-10.089,10.089v491.823c0,5.571,4.517,10.089,10.089,10.089h50.443     c5.571,0,10.089-4.517,10.089-10.089V254.739h403.547c3.325,0,6.437-1.638,8.318-4.381     C498.239,247.618,498.649,244.124,497.453,241.022z M64.315,491.823H34.049V20.177h30.266V491.823z M84.493,234.562V20.177     h388.801l-40.056,103.025c-0.912,2.342-0.916,4.94-0.011,7.284l40.113,104.075H84.493z" />
                    <path d="M135.566,66.837h47.291c5.571,0,10.089-4.517,10.089-10.089s-4.517-10.089-10.089-10.089h-47.291     c-18.427,0-33.419,14.992-33.419,33.419v23.961c0,18.427,14.992,33.419,33.419,33.419c0.537,0,1.062-0.054,1.576-0.135     c0.514,0.081,1.039,0.135,1.576,0.135h20.808c7.302,0,13.241,5.94,13.241,13.241v23.961c0,7.302-5.94,13.241-13.241,13.241     h-47.291c-5.571,0-10.089,4.517-10.089,10.089c0,5.571,4.517,10.089,10.089,10.089h47.291c18.427,0,33.419-14.992,33.419-33.419     V150.7c0-18.427-14.992-33.419-33.419-33.419h-20.808c-0.537,0-1.062,0.054-1.576,0.135c-0.515-0.081-1.039-0.135-1.576-0.135     c-7.302,0-13.241-5.94-13.241-13.241V80.079C122.325,72.777,128.265,66.837,135.566,66.837z" />
                    <path d="M246.542,66.837h47.291c5.571,0,10.089-4.517,10.089-10.089s-4.517-10.089-10.089-10.089h-47.291     c-18.427,0-33.419,14.992-33.419,33.419v47.291v47.291c0,18.427,14.992,33.419,33.419,33.419h47.291     c5.571,0,10.089-4.517,10.089-10.089c0-5.571-4.517-10.089-10.089-10.089h-47.291c-7.302,0-13.241-5.94-13.241-13.241v-37.202     h60.532c5.571,0,10.089-4.517,10.089-10.089s-4.517-10.089-10.089-10.089H233.3V80.079     C233.3,72.777,239.24,66.837,246.542,66.837z" />
                    <path d="M381.478,46.66h-23.961c-18.427,0-33.419,14.992-33.419,33.419v94.581c0,18.427,14.992,33.419,33.419,33.419h23.961     c18.427,0,33.419-14.992,33.419-33.419V80.079C414.896,61.652,399.905,46.66,381.478,46.66z M394.719,174.66     c0,7.302-5.94,13.241-13.241,13.241h-23.961c-7.302,0-13.241-5.94-13.241-13.241V80.079c0-7.302,5.94-13.241,13.241-13.241     h23.961c7.302,0,13.241,5.94,13.241,13.241V174.66z" />
                    <path d="M316.532,293.833c0-5.571-4.517-10.089-10.089-10.089h-186.64c-5.571,0-10.089,4.517-10.089,10.089     s4.517,10.089,10.089,10.089h186.64C312.015,303.921,316.532,299.404,316.532,293.833z" />
                    <path d="M479.212,324.099H296.355c-5.571,0-10.089,4.517-10.089,10.089s4.517,10.089,10.089,10.089h182.857     c5.571,0,10.089-4.517,10.089-10.089S484.783,324.099,479.212,324.099z" />
                  </g>
                </g>
              </g>
            </svg>
          );
        } else if (text === "meta-ads") {
          return <i className="bi bi-meta"></i>;
        }
        return (
          <>
            <img
              src={require("../../assets/images/xcare-api-icon.png")}
              width={14}
              height={14}
            ></img>
          </>
        );
      },
    },
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a: any, b: any) => moment(a.date).unix() - moment(b.date).unix(),
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "Contact",
      dataIndex: "customerNumber",
      sorter: (a: any, b: any) =>
        a.customerNumber.localeCompare(b.customerNumber),
      render: (text: any) => <p>{text}</p>,
    },
    {
      title: "Action",
      dataIndex: "status",
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
      render: (text: any, row: any) => {
        return (
          <div className="d-flex">
            {row?.recording && row?.callData?.recording_player && (
              <i
                className="bi bi-play-fill"
                onClick={() => {
                  window.open(row.callData.recording_player);
                }}
              ></i>
            )}
            {row?.verified === 1 || row?.verified === "1" ? (
              <>Auto Matched </>
            ) : (
              <StatusChange
                item={row}
                selectedClinic={selectedClinic}
                refetch={() => {
                  refetch();
                }}
              ></StatusChange>
            )}
            <SyncLead
              item={row}
              selectedClinic={selectedClinic}
              refetch={() => {
                refetch();
              }}
              patientList={patientList}
            ></SyncLead>
            <Note
              item={row}
              selectedClinic={selectedClinic}
              refetch={() => {
                refetch();
              }}
            ></Note>
          </div>
        );
      },
    },
    {
      title: "Note",
      dataIndex: "notes",
      render: (text: any, row: any) => (
        <OverlayTrigger
          placement="auto"
          overlay={<BSTooltip id="tooltip">{text}</BSTooltip>}
        >
          <p>
            {row.notes.substring(0, 25)}
            {row.notes.length > 25 ? "..." : ""}
          </p>
        </OverlayTrigger>
      ),
    },
  ];

  const mappedData = useMemo(() => {
    return data?.map((item: any) => {
      return {
        ...item,
      };
    });
  }, [data]);

  return (
    <Table
      className="p-0"
      columns={columns}
      dataSource={mappedData}
      pagination={{
        defaultPageSize: 50,
      }}
    />
  );
};

export const StatusChange = ({ item, selectedClinic, refetch,setOpenSyncModal, openSyncModal,patientList,selectedRow}: any) => {
  const [value, setValue] = useState(item?.status ?? "");
  const [loading, setLoading] = useState(false);
  const [showAcquisitionDialog, setShowAcquisitionDialog] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
  });
  const [showApprove, setShowApprove] = useState(false);

  useEffect(() => {
    setValue(item?.status);
  }, [item]);

  const handleChange = async (e: any) => {
    const newValue = e.target.value;
    setValue(newValue);
    if (newValue === "Acquisition") {
      setOpenSyncModal(true)
      // setShowAcquisitionDialog(true);
      setShowApprove(false);
      setValue("");
    } else if (newValue !== "") {
      setShowApprove(true);
      try {
        const res = await updateCallRecord(selectedClinic, item.id, {
          ...item,
          status: newValue,
        });
        if (res?.status?.msg === "Success") {
          setShowApprove(false);
          toast.success("Status updated successfully");
        }
        if (refetch) {
          await refetch();
        }
      } catch (error) {
        console.error("Error submitting acquisition form:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setShowApprove(false);
    }
  };

  const handleAcquisitionSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await updateCallRecord(selectedClinic, item.id, {
        ...formData,
        status: "Acquisition",
      });
      if (res?.status?.msg === "Success") {
        setShowAcquisitionDialog(false);
        setFormData({ firstName: "", lastName: "" });
      }
      if (refetch) {
        await refetch();
      }
    } catch (error) {
      console.error("Error submitting acquisition form:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex align-items-center gap-2">
        <select
          className="form-select form-select-sm"
          value={value}
          onChange={handleChange}
          disabled={loading}
        >
          <option value="">Select</option>
          <option value="Spam">SPAM</option>
          <option value="Existing Patient">Existing Patient</option>
          <option value="New Lead">New Lead</option>
          <option value="Campaign">Campaign</option>
          <option value="Opportunity Lost">Opportunity Lost</option>
          <option value="Repeat Call">Repeat Call</option>
          <option value="Clinic Follow Up">Clinic Follow Up</option>
          <option value="Patient Follow Up">Patient Follow Up</option>
          <option value="Acquisition">Acquisition</option>
        </select>

        {/* Acquisition Dialog */}
        <Dialog
          open={showAcquisitionDialog}
          onClose={() => setShowAcquisitionDialog(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Add Acquisition Details</DialogTitle>
          <DialogContent>
            <form onSubmit={handleAcquisitionSubmit} className="mt-3">
              <div className="mb-3">
                <label htmlFor="firstName" className="form-label">
                  First Name *
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="firstName"
                  required
                  value={formData.firstName}
                  onChange={(e) =>
                    setFormData({ ...formData, firstName: e.target.value })
                  }
                />
              </div>
              <div className="mb-3">
                <label htmlFor="lastName" className="form-label">
                  Last Name *
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="lastName"
                  required
                  value={formData.lastName}
                  onChange={(e) =>
                    setFormData({ ...formData, lastName: e.target.value })
                  }
                />
              </div>
              <div className="d-flex justify-content-end gap-2 mt-4">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowAcquisitionDialog(false)}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save"}
                </button>
              </div>
            </form>
          </DialogContent>
        </Dialog>

        {/* {loading && <Spinner size="sm" />}
      {value !== "" && showApprove && !loading && (
        // ... rest of your existing code ...
      )} */}
      </div>
        {/* <SyncLead
        open={openSyncModal}
        onClose={() => setOpenSyncModal(false)}
        item={selectedRow}
        selectedClinic={selectedClinic}
        refetch={refetch}
        patientList={patientList}
      /> */}
    </>
  );
};

export const SyncLeadx = ({
  item,
  selectedClinic,
  refetch,
  patientList,
}: any) => {
  const [patient, setPatient] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setShow(false);
  };
  const handleSave = async () => {
    try {
      setLoading(true);
      if (patient === "") return;
      const response = await matchCallLeads(selectedClinic, {
        id: item.id,
        rightId: patient,
      });
      setLoading(false);
      if (!response.status.error) {
        setPatient("");
        toast.success("Updated successfully");
        setShow(false);
        refetch();
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  return (
    <>
      <button
        onClick={() => {
          setShow(true);
        }}
      >
        <i className="bi bi-arrow-repeat"></i>
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        className="newcommon close-chat"
        centered
      >
        <Modal.Header>
          <div className="modal-title">Sync Lead</div>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => {
              handleClose();
            }}
          ></button>
        </Modal.Header>

        <Modal.Body>
          <div className="d-flex flex-row m-2 w-100">
            <div className="mb-3 w-100">
              <label className="form-label" htmlFor="email">
                Patient{" "}
              </label>
              <select
                className="form-select"
                value={patient}
                onChange={(e: any) => {
                  setPatient(e.target.value);
                }}
              >
                <option value="">Select</option>
                {patientList?.map((item: any) => {
                  return (
                    <option value={item.rightId}>
                      {item.fname} {item.lname}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-primary"
            disabled={patient === ""}
            onClick={() => {
              handleSave();
            }}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const SyncLead = ({
  item,
  selectedClinic,
  refetch,
  patientList,
  open,
  onClose,
}: any) => {
  const [patient, setPatient] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    if (!patient) return;

    try {
      setLoading(true);
      const response = await matchCallLeads(selectedClinic, {
        id: item.id,
        rightId: patient,
      });

      if (!response.status.error) {
        toast.success("Updated successfully");
        setPatient("");
        onClose();
        refetch?.();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={open}
      onHide={onClose}
      centered
      className="newcommon close-chat"
    >
      <Modal.Header>
        <div className="modal-title">Sync Lead</div>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onClose}
        />
      </Modal.Header>

      <Modal.Body>
        <div className="row align-items-center">
          <div className="col-4 fw-semibold">Patient</div>
          <div className="col-8">
            <select
              className="form-select"
              value={patient}
              onChange={(e) => setPatient(e.target.value)}
            >
              <option value="">Select Patient</option>
              {patientList?.map((p: any) => (
                <option key={p.rightId} value={p.rightId}>
                  {p.fname} {p.lname}
                </option>
              ))}
            </select>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button
          className="btn btn-primary"
          disabled={!patient || loading}
          onClick={handleSave}
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export const SyncForOnlineLead = ({
  item,
  selectedClinic,
  refetch,
  patientList,
}: any) => {
  const [patient, setPatient] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setShow(false);
  };
  const handleSave = async () => {
    try {
      setLoading(true);
      if (patient === "") return;
      const response = await manualMatchLeads(selectedClinic, {
        leftId: item?.leftId,
        rightId: patient,
        leftType: item?.leftType,
      });
      setLoading(false);
      if (!response.status.error) {
        setPatient("");
        toast.success("Updated successfully");
        setShow(false);
        refetch();
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  return (
    <>
      <button
        style={{ marginTop: "10px" }}
        onClick={() => {
          setShow(true);
        }}
      >
        <i className="bi bi-arrow-repeat"></i>
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        className="newcommon close-chat"
        centered
      >
        <Modal.Header>
          <div className="modal-title">Sync Online Lead</div>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => {
              handleClose();
            }}
          ></button>
        </Modal.Header>

        <Modal.Body>
          <div className="row align-items-center m-2">
            <div className="col-4 fw-semibold">{item?.name}</div>

            <div className="col-8">
              <select
                className="form-select"
                value={patient}
                onChange={(e: any) => setPatient(e.target.value)}
              >
                <option value="">Select Patient</option>
                {patientList?.map((item: any) => (
                  <option key={item?.rightId} value={item?.rightId}>
                    {item?.fname} {item?.lname}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-primary"
            disabled={patient === ""}
            onClick={() => {
              handleSave();
            }}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const Note = ({ item, selectedClinic, refetch }: any) => {
  const [note, setNote] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setShow(false);
  };
  const handleSave = async () => {
    try {
      setLoading(true);
      if (note === "") return;
      const response = await updateCall(selectedClinic, item.id, {
        notes: (item?.enotes + " " + note).trim(),
      });
      setLoading(false);
      if (!response.status.error) {
        setNote("");
        toast.success("Updated successfully");
        setShow(false);
        refetch();
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  return (
    <>
      <button
        onClick={() => {
          setShow(true);
        }}
      >
        <i className="bi bi-sticky ms-2"></i>
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        className="newcommon close-chat"
        centered
      >
        <Modal.Header>
          <div className="modal-title">Notes</div>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => {
              handleClose();
            }}
          ></button>
        </Modal.Header>

        <Modal.Body>
          <div className="d-flex flex-column flex-row m-2 w-100">
            <div className="mb-3 w-100">
              <label className="form-label" htmlFor="email">
                Note{" "}
              </label>
              <textarea
                className="form-control w-100"
                placeholder="Input note"
                id="note"
                value={note}
                onChange={(e) => {
                  setNote(e.target.value);
                }}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-primary"
            disabled={note?.trim()?.length === 0}
            onClick={() => {
              handleSave();
            }}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const CountInRevenue = ({ row, handleCountInRevenue }: any) => {
  const [shown, setShown] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  return (
    <div className="d-flex gap-2">
      {isLoading && <Spinner size="sm" />}
      {row.revenueCount === "0" && !isLoading && (
        <OverlayTrigger
          placement="auto"
          overlay={<BSTooltip id="tooltip">Include in revenue</BSTooltip>}
        >
          <div
            style={{
              width: "15px",
              height: "15px",
              backgroundColor: shown !== "" ? shown : "red",
              borderRadius: "100%",
              cursor: "pointer",
            }}
            onClick={() => {
              setIsLoading(true);
              handleCountInRevenue(row, "1", () => {
                setIsLoading(false);
                setShown("");
              });
            }}
            onMouseEnter={() => {
              setShown("green");
            }}
            onMouseLeave={() => {
              setShown("");
            }}
          ></div>
        </OverlayTrigger>
      )}
      {row.revenueCount === "1" && !isLoading && (
        <OverlayTrigger
          placement="auto"
          overlay={<BSTooltip id="tooltip">Exclude in revenue</BSTooltip>}
        >
          <div
            style={{
              width: "15px",
              height: "15px",
              backgroundColor: shown !== "" ? shown : "green",
              borderRadius: "100%",
              cursor: "pointer",
            }}
            onMouseEnter={() => {
              setShown("red");
            }}
            onClick={() => {
              setIsLoading(true);
              handleCountInRevenue(row, "0", () => {
                setIsLoading(false);
                setShown("");
              });
            }}
            onMouseLeave={() => {
              setShown("");
            }}
          ></div>
        </OverlayTrigger>
      )}
    </div>
  );
};

export const AcquisitionsTable = ({ data, columns }: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const mappedData = useMemo(() => {
    return data?.map((item: any) => {
      return {
        ...item,
      };
    });
  }, [data]);

  return (
    <Table
      className="p-0"
      columns={columns}
      dataSource={mappedData}
      pagination={{
        defaultPageSize: 50,
      }}
    />
  );
};
